"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var Icon_1 = __importDefault(require("../Icons/Icon"));
var constants_1 = require("./constants");
var StyledCheckbox = (0, material_1.styled)(material_1.Checkbox)(function (_a) {
    var theme = _a.theme;
    return ({
        // TODO: find all checkbox components if it's okay to move to checkboxStyles
        borderRadius: theme.shape.borderRadius,
        '.fa-xs': __assign({}, constants_1.SIZE_MAPPER.small),
        '.fa-sm': __assign({}, constants_1.SIZE_MAPPER.medium),
    });
});
var CheckboxNoLabel = function (_a) {
    var _b;
    var props = __rest(_a, []);
    return ((0, jsx_runtime_1.jsx)(StyledCheckbox, __assign({ typeof: "checkbox" }, props, { icon: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: pro_light_svg_icons_1.faSquare, size: props.size === 'small' ? 'xs' : 'sm' }), checkedIcon: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: pro_solid_svg_icons_1.faSquareCheck, size: props.size === 'small' ? 'xs' : 'sm', color: (_b = props === null || props === void 0 ? void 0 : props.color) !== null && _b !== void 0 ? _b : 'primary' }) })));
};
exports.default = CheckboxNoLabel;
